import { Controller } from "@hotwired/stimulus"

export default class AdminOrderListController extends Controller {
  static targets = [
    "orderItem",
    "updateOrderStatusModal",
    "orderId",
    "price",
    "lineName",
    "packageName",
    "paymentMethod",
  ]

  closeModal() {
    this.updateOrderStatusModalTarget.close()
  }

  showUpdateOrderStatusModal(e) {
    const order = JSON.parse(e.currentTarget.dataset.order)
    const price = e.currentTarget.dataset.priceInclVat
    const lineName = e.currentTarget.dataset.lineDisplayName
    const packageName = e.currentTarget.dataset.packageName
    const paymentMethod = e.currentTarget.dataset.paymentMethod

    // เปิดโมดัลได้ทุกช่องทางที่ค้าง pending — PromptPay ที่ตรวจสลิปอัตโนมัติไม่ผ่านก็ต้องยืนยันมือได้
    if (order.status === "pending") {
      this.orderIdTarget.textContent = order.id
      this.priceTarget.textContent = price
      this.lineNameTarget.textContent = lineName
      this.packageNameTarget.textContent = packageName
      this.paymentMethodTarget.textContent = paymentMethod

      const form = this.updateOrderStatusModalTarget.querySelector("form")
      form.action = `/admin/orders/${order.id}`

      this.updateOrderStatusModalTarget.showModal()
    }
  }
}
